import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import FormRender from "../../components/FormRender";
import { TableCustom } from "../../components/Table";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import useAxiosInstance from "../../hooks/useAxios";

const InnerForm = ({ setTables }) => {
  const [formData, setFormData] = useState({
    chat_id: "",
  });

  return (
    <div className="">
      <FormRender
        formData={formData}
        formSettings={[
          {
            label: "Chat ID",
            type: "text",
            saveKey: "chat_id",
          },
        ]}
        setFormData={setFormData}
      />
      <button
        className="px-2 py-1 mt-2 text-sm font-medium text-white bg-black rounded-md disabled:cursor-not-allowed"
        onClick={() => {
          if (!formData.chat_id) {
            toast.error("Please enter a Chat ID");
            return;
          }
          setTables((prev) => [
            ...prev,
            { id: uuid(), chat_id: formData.chat_id },
          ]);
          setFormData({ chat_id: "" });
        }}
      >
        +add
      </button>
    </div>
  );
};

const ChatMigration = () => {
  const axiosInstance = useAxiosInstance();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    transfer_to: "",
  });
  const [chatIds, setChatIds] = useState([]);
  const [response, setResponse] = useState({ success: [], failed: [] });
  const { organisation } = useSelector((e) => e.globalAuth);
  const [selectedUserOrg, setSelectedUserOrg] = useState("");

  useEffect(() => {
    setFormData((prev) => ({ ...prev, organisation: selectedUserOrg }));
  }, [selectedUserOrg]);

  return (
    <div className="">
      <div className={` w-full justify-center p-5 ${"items-start "} flex`}>
        <div className="w-[676px] p-3 mt-5 border rounded-lg bg-white">
          <p className="mb-4 text-2xl font-semibold">Migrate Chat</p>
          <FormRender
            formData={formData}
            formSettings={[
              {
                label: "Username(Single Select Only)*",
                type: "user",
                saveKey: "transfer_to",
              },
              {
                label: "Organization*",
                type: "select",
                saveKey: "organisation",
                readonly: true,
              },
            ]}
            setSelectedUserOrg={setSelectedUserOrg}
            setFormData={setFormData}
            select_options={{
              organisation:
                Object?.keys(organisation || {})?.map((ot) => ({
                  label: ot,
                  value: ot,
                })) || [],
            }}
          />
          <InnerForm setTables={setChatIds} />
          <TableCustom
            columns={[
              {
                label: "Chat ID",
                key: "chat_id",
                width: "100%",
              },
            ]}
            data={{ data: chatIds }}
            loading={isLoading}
            handleEdit={null}
            handleDelete={(id) => {
              setChatIds((prev) => prev.filter((item) => item.id !== id));
            }}
            handleSelect={null}
            className="max-w-full"
          />

          <button
            disabled={isLoading}
            className="px-2 py-1 mt-2 text-sm font-medium text-white bg-black rounded-md disabled:cursor-not-allowed"
            onClick={async () => {
              const newUserId = Number(Object.keys(formData.transfer_to)[0]);
              if (!newUserId) {
                toast.error("Please select a user");
                return;
              }
              if (chatIds.length === 0) {
                toast.error("Please add at least one Chat ID");
                return;
              }
              setResponse({ success: [], failed: [] });
              setIsLoading(true);
              const results = await Promise.allSettled(
                chatIds.map((item) =>
                  axiosInstance.post(
                    `/chats/messages/sandbox/move/${item.chat_id}/`,
                    {
                      new_user_id: newUserId,
                    },
                  ),
                ),
              );
              const success = [];
              const failed = [];
              results.forEach((result, idx) => {
                if (result.status === "fulfilled") {
                  success.push(chatIds[idx].chat_id);
                } else {
                  failed.push(chatIds[idx].chat_id);
                }
              });
              setIsLoading(false);
              setResponse({ success, failed });
              if (failed.length === 0) {
                setChatIds([]);
                setFormData({ transfer_to: "" });
                setSelectedUserOrg("");
                toast.success(
                  `All ${success.length} chats migrated successfully`,
                );
              } else if (success.length === 0) {
                toast.error("All migrations failed");
              } else {
                toast.info(
                  `${success.length} succeeded, ${failed.length} failed`,
                );
              }
            }}
          >
            {isLoading ? "migrating...." : "Save"}
          </button>

          <div className="mt-3">
            <p className="text-base font-semibold">Status</p>
            {Object.keys(response).map((key) => {
              if (!response[key].length) {
                return null;
              }
              return (
                <>
                  <p className="text-sm font-semibold uppercase">
                    {key.split("_").join(" ")}
                  </p>
                  <div>
                    {response[key].map((it) => {
                      return (
                        <li key={it} className="text-xs font-medium">
                          {it}
                        </li>
                      );
                    })}
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMigration;
